var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIconTool(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.701,
    height: 16.621,
    viewBox: "0 0 16.701 16.621",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-513 -210.463) translate(-539.621 -10.031)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1069.322 236.037l-1.077 1.078-4.384-4.384 1.078-1.077z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1058.956 220.494a6.335 6.335 0 1 0 6.335 6.335 6.335 6.335 0 0 0-6.335-6.335zm0 11.24a4.9 4.9 0 1 1 4.9-4.9 4.9 4.9 0 0 1-4.9 4.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.008,
    cy: 4.008,
    r: 4.008,
    transform: "translate(1054.948 222.821)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconTool);
export default __webpack_public_path__ + "static/media/search-icon-tool.c731128c.svg";
export { ForwardRef as ReactComponent };